/**
 * @description `BlogHomePanel` CMS component key: lazily loads the Blog homepage module so
 *              its styles stay out of the main bundle.
 * @filename index.tsx
 */

import * as React from "react";
import Loadable from "react-loadable";
import OptionsWithoutRender = LoadableExport.OptionsWithoutRender;
import { Loader } from "../../page/loader";

const loadableOptions: OptionsWithoutRender<{}> = {
  loader: () => import("../../../modules/blog").then((module) => module.BlogHomePanel) as Promise<any>,
  loading: () => <Loader isActive={true} />,
};

export const BlogHomePanel = Loadable(loadableOptions);
